import './App.css';
import BackgroundMap from './components/shared/BackgroundMap';
import DesktopLayout from './components/desktop/DesktopLayout';
import MobileLayout from './components/mobile/MobileLayout';
import { useIsMobile } from './hooks/useMediaQuery';

function App() {
  const isMobile = useIsMobile();

  return (
    <div
      className="relative min-h-screen w-full max-w-full"
      style={{ minHeight: '100vh', overflow: 'hidden' }}
    >
      {/* Full-screen background map */}
      <BackgroundMap />

      {/* Responsive layout */}
      {isMobile ? <MobileLayout /> : <DesktopLayout />}
    </div>
  );
}

export default App;
